import React from 'react';

const Logo = props => {
  return <img alt="Logo" src="/static/plaato_pro_logo.svg" {...props} />;
};

export default Logo;
